// for mp and rr order
export const orderReceivableStatus = {
  NEW: 'NEW',
  READY_FOR_APPROVAL: 'READY_FOR_APPROVAL',
  PENDING_APPROVAL: 'PENDING_APPROVAL',
  APPROVED: 'APPROVED',
  PENDING_INVOICE: 'PENDING_INVOICE',
  INVOICED: 'INVOICED',
  PAID: 'PAID',
  VOID: 'VOID',
  UNCLAIMABLE: 'UNCLAIMABLE',
  PARTIALLY_PAID: 'PARTIALLY_PAID',
};

export const listingTypeNoticeHint = 'cms:cms.reconciliation.notice.hint';

export const listingTypeNoticeContent = [
  {
    title: 'cms:cms.reconciliation.notice.list.title',
    description: 'cms:cms.reconciliation.notice.list.description',
  },
  {
    title: 'cms:cms.reconciliation.notice.book.title',
    description: 'cms:cms.reconciliation.notice.book.description',
  },
  {
    title: 'cms:cms.reconciliation.notice.student.com.title',
    description: 'cms:cms.reconciliation.notice.student.com.description',
  },
  {
    title: 'cms:cms.reconciliation.notice.student.suite.title',
    description: 'cms:cms.reconciliation.notice.student.suite.description',
  },
];
